export default {
    imageAIFormRules: {
        enterDescription: 'Vänligen ange beskrivning',
        invalidDescription: 'Var god ange en giltig beskrivning',
        enterNumberOfVariations: 'Vänligen välj antal variationer',
        invalidNumberOfVariations: 'Du kan generera högst 4 och lägst 1 varianter',
        enterStyle: 'Var god välj åtminstone en stil',
    },
};
